import { ArrowDropDown } from '@mui/icons-material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, Menu, MenuItem, Stack, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as IconFilter2 } from 'assets/icons/IconFilter2.svg';
import SearchPage from 'components/Layout/SearchPage';
import { TooltipCC } from 'components/common';
import DatePickerCC, { RANGE_TIME_DATEPICKER } from 'components/common/DatePickerCC/DatePickerCC';
import DatePickerCalenderCC from 'components/common/DatePickerCC/DatePickerCalenderCC';
import { SearchCC } from 'components/common/SearchCC';
import SwipePage from 'components/common/SwipePage';
import { CALENDAR_VIEW } from 'constants/common';
import { useMenuCC } from 'hooks';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import theme from 'theme';
import { RenderIconCurrentDay, getTitleBtnCalendar } from 'utils/helpers';
import FilterMeeting from './components/FilterMeeting';
import FilterStatusMeeting from './components/FilterStatusMeeting';
import FilterTypeMeeting from './components/FilterTypeMeeting';
import { IconNextCalendar, IconPrevCalendar } from './components/IconManagerMeeting';
import useManagerMeeting, { LABEL_TYPE_MEETING, TYPE_MEETING } from './hook/useManagerMeeting';

function getNameOfView(view) {
    return view === CALENDAR_VIEW.TIME_GRID_WEEK ? 'calendar.week' : view === CALENDAR_VIEW.TIME_GRID_DAY ? 'calendar.day' : 'calendar.list'
}

/**
 * Chức năng tìm kiếm cuộc họp
 * @param {*} param0 
 * @returns 
 */
const SearchMeetings = ({ diffTime, setDiffTime, currentTypeView, todayInView, handleChangeToday, handleNextCalendar, handleChangeView, query, updateQuery }) => {
    const { setAnchorEl } = useMenuCC()
    const { open: openTypeMeeting, anchorEl: elTypeMeeting, setAnchorEl: setElTypeMeeting } = useMenuCC()
    const { typeMeeting, statusMeeting, setStatusMeeting, handleUpdateTypeMeeting, handleUpdateStatusMeeting, handleChangeTimeInCalendar } = useManagerMeeting()
    const { open: openMenu, anchorEl: anchorElMenu, setAnchorEl: setAnchoElMenu } = useMenuCC()
    const { t } = useTranslation()
    const isPC = useMediaQuery(theme.breakpoints.up('lg'))
    const isLargePC = useMediaQuery(theme.breakpoints.up('xl'))
    const [roomName, setRoomName] = useState(query?.roomName)
    const dispatch = useDispatch()

    const handleSearchRoomName = (roomName) => {
        dispatch(
            updateQuery({
                ...query,
                roomName: roomName
            })
        )
    }

    const handleClick = (e, id) => {
        if (id === 'menu') setAnchoElMenu(e.currentTarget)
        else setAnchorEl(e.currentTarget)
    }

    const handleClose = (id) => {
        if (id === 'menu') setAnchoElMenu(false)
        else setAnchorEl(false)
    }

    const handleChangeViewCalendar = (view) => {
        handleChangeView(view)
        handleClose('menu')
    }

    useEffect(() => {
        document.addEventListener('wheel', function(event) {
            setAnchorEl(null)
        });

        setStatusMeeting(query?.statusDisplay)

        return () => {
            document.removeEventListener('wheel', function(event) {
                setAnchorEl(null)
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SearchPage isFull={true}>
            {/* Giao diện ở chế độ mobile */}
            <Stack sx={{ width: 1, display: { xs: 'flex', lg: 'none' } }} gap={1} mt={1} mb={1}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {/* Thay đổi thời gian của lịch */}
                    <TooltipCC title={t(getTitleBtnCalendar(currentTypeView).prev)}>
                        <IconButton onClick={() => handleNextCalendar('prev')} aria-label="delete">
                            <ArrowBackIosIcon />
                        </IconButton>
                    </TooltipCC>
                    <TooltipCC title={t(getTitleBtnCalendar(currentTypeView).tooltip)} >
                        <span>
                            <Button disabled={todayInView} onClick={handleChangeToday} sx={{ color: `${theme.palette.text.primary} !important` }} variant='text' >{t(getTitleBtnCalendar(currentTypeView).btn)}</Button>
                        </span>
                    </TooltipCC>
                    <TooltipCC title={t(getTitleBtnCalendar(currentTypeView).next)}>
                        <IconButton onClick={() => handleNextCalendar('next')} aria-label="delete">
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </TooltipCC>
                    {/* Chọn loại lịch */}
                    <Box sx={{ marginLeft: theme.spacing(2.5) }}>
                        <Button
                            variant='text'
                            id="type-view"
                            aria-controls={openMenu ? 'view-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openMenu ? 'true' : undefined}
                            onClick={(e) => handleClick(e, 'menu')}
                            startIcon={<IconFilter2 />}
                            endIcon={<ArrowDropDown />}
                            sx={{ gap: {xs: '8px', sm: 'unset'} }}
                        >
                            {t(getNameOfView(currentTypeView))}
                        </Button>
                        <Menu
                            id="view-menu"
                            anchorEl={anchorElMenu}
                            open={openMenu}
                            onClose={() => handleClose('menu')}
                            MenuListProps={{
                                'aria-labelledby': 'type-view',
                            }}
                        >
                            <MenuItem sx={{ display: { xs: 'none', sm: 'flex'} }} onClick={() => handleChangeViewCalendar(CALENDAR_VIEW.TIME_GRID_WEEK)}>{t('calendar.week')}</MenuItem>
                            <MenuItem onClick={() => handleChangeViewCalendar(CALENDAR_VIEW.TIME_GRID_DAY)}>{t('calendar.day')}</MenuItem>
                            <MenuItem onClick={() => handleChangeViewCalendar(CALENDAR_VIEW.LIST_WEEK)}>{t('calendar.list')}</MenuItem>
                        </Menu>
                    </Box>
                </Box>
                {/* Menu tìm kiếm nâng cao */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <SwipePage>
                        <FilterMeeting setDiffTime={setDiffTime} type={currentTypeView} handleChangeTimeInCalendar={handleChangeTimeInCalendar} />
                    </SwipePage>
                    {/* <FormGroup sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: color.white, borderRadius: '6px', overflow: 'hidden', flexWrap: 'nowrap' }}>
                        <TextField className='tf-search' placeholder={t('placeholder.enterRoomName')} />
                        <Box component={'div'} onClick={() => console.log("Searching.....")} sx={{ backgroundColor: '#ee0033', display: 'flex', width: theme.spacing(4.5), height: theme.spacing(4.5), alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                            <Search sx={{ color: 'white' }} />
                        </Box>
                    </FormGroup> */}
                    <SearchCC backgroundColor={"#FFFF"} value={roomName} setValue={setRoomName} handleValue={handleSearchRoomName} />
                </Box>
            </Stack>
            {/* Giao diện ở chế độ large pc */}
            <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', justifyContent: 'space-between', width: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* Đổi thời gian & loại lịch */}
                    <FilterTypeMeeting currentTypeView={currentTypeView} handleChangeView={handleChangeView}/>
                    <TooltipCC title={t(getTitleBtnCalendar(currentTypeView).tooltip)} >
                        <span>
                            {/* disabled={todayInView} */}
                            <Button 
                                id='btn-current-week'
                                onClick={handleChangeToday} 
                                sx={{ marginRight: 2, whiteSpace: 'nowrap' }} 
                                variant='text' startIcon={<RenderIconCurrentDay view={currentTypeView} />} >
                                    <Typography fontWeight={600}>{t(getTitleBtnCalendar(currentTypeView).btn)}</Typography>
                                </Button>
                        </span>
                    </TooltipCC>
                    <TooltipCC title={t(getTitleBtnCalendar(currentTypeView).prev)}>
                        <IconButton onClick={() => handleNextCalendar('prev')} aria-label="delete">
                            <IconPrevCalendar />
                        </IconButton>
                    </TooltipCC>
                    <TooltipCC title={t(getTitleBtnCalendar(currentTypeView).next)}>
                        <IconButton onClick={() => handleNextCalendar('next')} aria-label="delete">
                            <IconNextCalendar />
                        </IconButton>
                    </TooltipCC>
                    {/* Thay đổi thời gian tìm kiếm */}
                    
                    {
                        currentTypeView === CALENDAR_VIEW.TIME_GRID_DAY ? 
                            <DatePickerCalenderCC rangeTimePicker={currentTypeView === CALENDAR_VIEW.TIME_GRID_DAY ? RANGE_TIME_DATEPICKER.DAY : RANGE_TIME_DATEPICKER.WEEK} setDiffTime={setDiffTime} handleChangeTimeInCalendar={handleChangeTimeInCalendar} /> :
                            <DatePickerCC diffTime={diffTime} rangeTimePicker={currentTypeView === CALENDAR_VIEW.TIME_GRID_DAY ? RANGE_TIME_DATEPICKER.DAY : RANGE_TIME_DATEPICKER.WEEK} setDiffTime={setDiffTime} handleChangeTimeInCalendar={handleChangeTimeInCalendar} />
                    }
                    {/* <WeekPicker setDiffTime={setDiffTime} type={currentTypeView} handleChangeTimeInCalendar={handleChangeTimeInCalendar} /> */}
                    {/* Thay đổi loại cộc họp */}
                    {
                        isPC && !isLargePC && <Fragment>
                            <Button
                                className='btn-greyIL05'
                                variant='outlined'
                                endIcon={<ArrowDropDown />}
                                onClick={(e) => setElTypeMeeting(e.currentTarget)}
                                sx={{
                                    mx: 2
                                }}
                            >
                                {t('mnMeeting.typeMeeting')}
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={elTypeMeeting}
                                open={openTypeMeeting}
                                onClose={() => setElTypeMeeting(false)}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <FormGroup sx={{ display: 'flex', flexDirection: 'column', padding: `0 ${theme.spacing(2.5)}` }}>
                                    {
                                        Object.values(TYPE_MEETING).map(type => (
                                            <FormControlLabel sx={{ mr: 4 }} key={type} onChange={(e) => handleUpdateTypeMeeting(e.target?.value, e.target?.checked)} control={<Checkbox checked={typeMeeting.includes(type)} />} label={t(LABEL_TYPE_MEETING[type])} value={type} />
                                        ))
                                    }
                                </FormGroup>
                            </Menu>
                        </Fragment>
                    }
                    <FormGroup sx={{ display: { xs: 'none', xl: 'flex' }, flexDirection: 'row', mx: 2 }}>
                        {
                            Object.values(TYPE_MEETING).map(type => (
                                <FormControlLabel sx={{ mr: 4 }} key={type} onChange={(e) => handleUpdateTypeMeeting(e.target?.value, e.target?.checked)} control={<Checkbox checked={typeMeeting.includes(type)} />} label={t(LABEL_TYPE_MEETING[type])} value={type} />
                            ))
                        }
                    </FormGroup>
                </Box>
                {/* Thay đổi trạng thái cuộc họp & tìm kiếm theo tên cuộc họp */}
                <FilterStatusMeeting statusMeeting={statusMeeting} handleUpdateStatusMeeting={handleUpdateStatusMeeting} roomName={roomName} setRoomName={setRoomName} handleSearchRoomName={handleSearchRoomName}/>
            </Box>
        </SearchPage>
    )
}

export default SearchMeetings